import { render, staticRenderFns } from "./UniqueProject.vue?vue&type=template&id=04c4b0a6&scoped=true&"
import script from "./UniqueProject.vue?vue&type=script&lang=js&"
export * from "./UniqueProject.vue?vue&type=script&lang=js&"
import style0 from "./UniqueProject.vue?vue&type=style&index=0&id=04c4b0a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c4b0a6",
  null
  
)

export default component.exports